// Who an email is from and to, for a timeline row. A synced row's userName is
// the teammate whose mailbox the copy came from, which is not the sender: a
// message Bonner sent Chad arrives from Chad's mailbox. Graph stores parties
// as { emailAddress: { name, address } }; older rows carry { name, address }.
type Party = { emailAddress?: { name?: string; address?: string }; name?: string; address?: string };

function partyLabel(p: Party | null | undefined): string | null {
  const name = (p?.emailAddress?.name ?? p?.name)?.trim();
  const address = (p?.emailAddress?.address ?? p?.address)?.trim();
  return name || address || null;
}

export function senderLabel(from: Party | null | undefined): string | null {
  return partyLabel(from);
}

export function recipientLabel(to: Party[] | null | undefined): string | null {
  const first = partyLabel(to?.[0]);
  if (!first) return null;
  const more = (to?.length ?? 0) - 1;
  return more > 0 ? `${first} +${more}` : first;
}
